import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import queryString from 'query-string'
import ProtectedRoute from './ProtectedRoute'
import Profile from './pages/Profile'
import ReminderConfirm from './pages/ReminderConfirm'
import ReminderSuccess from './pages/ReminderSuccess'
import Users from './pages/Users'
import Companies from './pages/Companies'
import Company from './pages/Company'
import Case from './pages/Case'
import Cases from './pages/Cases'
import Applications from './pages/Applications'
import Thanks from './pages/Thanks'
import NotFound from './pages/NotFound'
import About from './pages/About'
import Faq from './pages/Faq'
import PrivacyStatement from './pages/PrivacyStatement'
import Settings from './pages/Settings'
import TermsAndConditions from './pages/Onboarding'
import {
  getAppFeatures,
  isAdmin,
  isProjectAdmin,
  isManager,
  getCurrentUserId
} from './redux/selectors'
import Projects from './pages/Projects'
import Project from './pages/Project'

const Router = ({ currentUserId, isAdmin, isProjectAdmin, isManager, reactAppManagerShowEmloyeesEnabled, reactAppApplicationsEnabled }) => (
  <Switch>
    <ProtectedRoute
      exact
      path="/"
      isAllowed={true}
      isManager={isManager}
      isProjectAdmin={isProjectAdmin}
      isAdmin={isAdmin}
      currentUserId={currentUserId}
      component={Profile}
    />
    <ProtectedRoute path="/profile" isAllowed={true} component={Profile} />
    <ProtectedRoute
      path="/onboarding"
      isAllowed={true}
      component={TermsAndConditions}
    />
    <ProtectedRoute
      path="/users/:userId"
      isAllowed={true}
      isManager={isManager && reactAppManagerShowEmloyeesEnabled}
      isAdmin={isAdmin}
      currentUserId={currentUserId}
      component={(props) => (
        <Profile {...props} userId={props.match.params.userId} />
      )}
    />
    <ProtectedRoute
      path="/reminder/confirm"
      isAllowed={true}
      render={(props) => {
        const usersQs = queryString.parse(props.location.search).users
        const userIds = usersQs ? usersQs.split(',') : []
        return <ReminderConfirm userIds={userIds} />
      }}
    />
    <ProtectedRoute
      path="/reminder/success"
      isAllowed={true}
      render={ReminderSuccess}
    />
    <ProtectedRoute
      path="/users"
      isAllowed={
        isAdmin ||
        (isManager && reactAppManagerShowEmloyeesEnabled)
      }
      component={Users}
    />
    <ProtectedRoute
      path="/companies/:companyId"
      isAllowed={isAdmin}
      component={(props) => (
        <Company
          {...props}
          companyId={decodeURIComponent(props.match.params.companyId)}
        />
      )}
    />
    <ProtectedRoute
      path="/companies"
      isAllowed={isAdmin}
      component={Companies}
    />
    <ProtectedRoute
      path="/cases/:caseId"
      isAllowed={true}
      isManager={isManager && reactAppManagerShowEmloyeesEnabled}
      isAdmin={isAdmin}
      currentUserId={currentUserId}
      component={(props) => (
        <Case {...props} caseId={props.match.params.caseId} />
      )}
    />
    <ProtectedRoute
      path="/cases"
      isAllowed={
        isAdmin ||
        (isManager && reactAppManagerShowEmloyeesEnabled)
      }
      component={Cases}
    />
    <ProtectedRoute
      path="/applications"
      isAllowed={
        (isAdmin || isManager) && reactAppApplicationsEnabled
      }
      component={Applications}
    />
    <ProtectedRoute
      path="/projects/:projectId"
      isAllowed={isProjectAdmin}
      component={(props) => (
        <Project
          {...props}
          projectId={decodeURIComponent(props.match.params.projectId)}
        />
      )}
    />
    <ProtectedRoute
      path="/projects"
      isAllowed={isProjectAdmin}
      component={Projects}
    />
    <ProtectedRoute path="/thanks" isAllowed={true} component={Thanks} />
    <ProtectedRoute path="/about" isAllowed={true} component={About} />
    <ProtectedRoute path="/faq" isAllowed={true} component={Faq} />
    <ProtectedRoute
      path="/privacy"
      isAllowed={true}
      component={PrivacyStatement}
    />
    <ProtectedRoute
      path="/settings"
      isAllowed={isAdmin}
      component={Settings}
    />
    <Route path="/" isAllowed={true} component={NotFound} />
  </Switch>
)

const mapStateToProps = (state) => {
  const appFeatures = getAppFeatures(state)
  return {
    reactAppManagerShowEmloyeesEnabled: appFeatures.reactAppManagerShowEmloyeesEnabled,
    reactAppApplicationsEnabled: appFeatures.reactAppApplicationsEnabled,
    currentUserId: getCurrentUserId(state),
    isAdmin: isAdmin(state),
    isProjectAdmin: isProjectAdmin(state),
    isManager: isManager(state),
  }
}

export default connect(mapStateToProps)(Router)
